(function () {
  'use strict';

  function berlinNowParts() {
    var parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Berlin',
      year: 'numeric', month: '2-digit', day: '2-digit',
      weekday: 'short', hour: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date());
    var out = {};
    parts.forEach(function (part) { out[part.type] = part.value; });
    return out;
  }

  function addBusinessDays(date, count) {
    var result = new Date(date.getTime());
    var added = 0;
    while (added < count) {
      result.setUTCDate(result.getUTCDate() + 1);
      var day = result.getUTCDay();
      if (day !== 0) added += 1;
    }
    return result;
  }

  function nextBusinessDay(date) {
    var result = new Date(date.getTime());
    do { result.setUTCDate(result.getUTCDate() + 1); }
    while (result.getUTCDay() === 0);
    return result;
  }

  function formatDate(date, locale) {
    return new Intl.DateTimeFormat(locale === 'de' ? 'de-DE' : 'en-GB', {
      day: 'numeric', month: 'short', timeZone: 'UTC'
    }).format(date);
  }

  function render(root) {
    var target = root.querySelector('[data-purchase-assurance-delivery]');
    if (!target) return;

    var now = berlinNowParts();
    var base = new Date(Date.UTC(Number(now.year), Number(now.month) - 1, Number(now.day), 12));
    var weekday = base.getUTCDay();
    var beforeCutoff = Number(now.hour) < Number(root.dataset.cutoffHour || 14);
    var dispatch = weekday !== 0 && beforeCutoff ? base : nextBusinessDay(base);
    var isSameDay = dispatch.getTime() === base.getTime();
    var minDate = addBusinessDays(dispatch, Number(root.dataset.transitMin || 4));
    var locale = root.dataset.locale || document.documentElement.lang || 'en';

    target.textContent = root.dataset.orderLabel + ' → ' +
      (isSameDay
        ? root.dataset.sameDayLabel
        : root.dataset.dispatchLabel + ' ' + formatDate(dispatch, locale)) + ' → ' +
      root.dataset.deliveryLabel + ' ' + formatDate(minDate, locale) + ' ' + root.dataset.approxLabel;
  }

  /**
   * Hold the Trustpilot rotation until the strip is actually on screen.
   *
   * The set plays once and stops on the last review. Started at page load it
   * would routinely finish while the shopper was still up in the gallery, and
   * they would scroll down to a strip that had already said everything it had
   * to say. Tying the start to visibility means the one pass happens while
   * someone is there to read it.
   *
   * Fires once and then disconnects: re-running on every scroll back would
   * replay the same five quotes, which is the repetition this is avoiding.
   * Without JS, or on a browser with no IntersectionObserver, the CSS leaves
   * the first quote visible and static rather than blank.
   */
  function watchRotator(root) {
    var rotator = root.querySelector('[data-tp-rotator]');
    if (!rotator || rotator.hasAttribute('data-tp-running')) return;

    var start = function () { rotator.setAttribute('data-tp-running', ''); };

    if (!('IntersectionObserver' in window)) {
      start();
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.disconnect();
        start();
      });
    }, { threshold: 0.6 });

    observer.observe(rotator);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-purchase-assurance]').forEach(function (root) {
      render(root);
      watchRotator(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
